import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Countdown from "../home/Countdown";

const ExploreItems = ({ explore, loadingState, filterChangeHandler }) => {
  const [loadCards, setLoadCards] = useState(8);
  const loadMore = () => {
    if (loadCards >= explore.length) {
      return
    } else {
      setLoadCards(loadCards + 4)
    }
  };
  return (
    <>
      <div>
        <select id="filter-items" defaultValue="" onChange={filterChangeHandler}>
          <option value="">Default</option>
          <option value="price_low_to_high">Price, Low to High</option>
          <option value="price_high_to_low">Price, High to Low</option>
          <option value="likes_high_to_low">Most liked</option>
        </select>
      </div>
      {loadingState ?
        new Array(8).fill(0).map((_, index) => (
          <div
            key={index}
            className="d-item col-lg-3 col-md-6 col-sm-6 col-xs-12"
            style={{ display: "block", backgroundSize: "cover" }}
          >
            <div className="nft__item">
              <div className="author_list_pp">
                <div className="skeleton-box lazy" style={{ width: "50px", height: "50px", borderRadius: "50%" }}>
                </div>
                <i className="fa fa-check"></i>
              </div>
              <div className="de_countdown">0h 0m 0s</div>

              <div className="nft__item_wrap">
                <div className="skeleton-box" style={{ width: "100%", height: "200px" }} />
              </div>
              <div className="nft__item_info">
                <div className="skeleton-box"
                  style={{ width: "100px", height: "20px", borderRadius: "5px" }}>
                </div>
                <br />
                <div className="skeleton-box"
                  style={{ width: "60px", height: "20px", borderRadius: "5px", marginRight: "65%" }}>
                </div>
                <div className="nft__item_like">
                  <i className="fa fa-heart"></i>
                  <span>0</span>
                </div>
              </div>
            </div>
          </div>
        ))
        :
        explore.slice(0, loadCards).map(({ id, authorId, authorImage, nftImage, nftId, title, price, likes, expiryDate }) => (
          <div
            key={id}
            className="d-item col-lg-3 col-md-6 col-sm-6 col-xs-12"
            style={{ display: "block", backgroundSize: "cover" }}
          >
            <div className="nft__item" data-aos="fade"
            data-aos-duration="3000">
              <div className="author_list_pp">
                <Link
                  to={`/author/${authorId}`}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                >
                  <img className="lazy" src={authorImage} alt={`Profile pic for user: ${authorId}`} />
                  <i className="fa fa-check"></i>
                </Link>
              </div>
              <Countdown expiryDate={expiryDate} />

              <div className="nft__item_wrap">
                <div className="nft__item_extra">
                  <div className="nft__item_buttons">
                    <button>Buy Now</button>
                    <div className="nft__item_share">
                      <h4>Share</h4>
                      <a href="" target="_blank" rel="noreferrer">
                        <i className="fa fa-facebook fa-lg"></i>
                      </a>
                      <a href="" target="_blank" rel="noreferrer">
                        <i className="fa fa-twitter fa-lg"></i>
                      </a>
                      <a href="">
                        <i className="fa fa-envelope fa-lg"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <Link to={`/item-details/${nftId}`}>
                  <img src={nftImage} className="lazy nft__item_preview" alt={`NFT image titled: ${title}`} />
                </Link>
              </div>
              <div className="nft__item_info">
                <Link to={`/item-details/${nftId}`}>
                  <h4>{title}</h4>
                </Link>
                <div className="nft__item_price">{price} ETH</div>
                <div className="nft__item_like">
                  <i className="fa fa-heart"></i>
                  <span>{likes}</span>
                </div>
              </div>
            </div>
          </div>
        ))
      }

      {(loadCards < explore.length) ? 
      (<div className="col-md-12 text-center">
        <Link to="" id="loadmore" className="btn-main lead" onClick={loadMore} data-aos="fade-up" data-aos-duration="3000">
          Load more
        </Link>
      </div>)
        :
        null
      }

    </>
  );
};

export default ExploreItems;
